import { setupLayouts } from 'virtual:generated-layouts'
import generatedRoutes from 'virtual:generated-pages'
import { createRouter, createWebHistory } from 'vue-router'
import { prefixRoutes } from '../router'
import getBeforeEachRouteGuards from '../router/guards/beforeEach'
import getAfterEachRouteGuards from '../router/guards/afterEach'

const routesWithLayouts = setupLayouts(generatedRoutes)
const routes = prefixRoutes(routesWithLayouts)
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },
  strict: false,
})

const beforeEachRouteGuards = getBeforeEachRouteGuards(router)
const afterEachRouteGuards = getAfterEachRouteGuards(router)

beforeEachRouteGuards.forEach(guard => router.beforeEach(guard))
afterEachRouteGuards.forEach(guard => router.afterEach(guard))

export function install(app) {
  const IS_STORYBOOK = window.IS_STORYBOOK
  if (!IS_STORYBOOK)
    app.use(router)
}

export { router }
